<template>
  <div class="as-list">
    <div class="tab">
      <div v-for="(item,index) in tabList" :key="index" :class="['tab-item',item.value === activeIndex?'tab-active':'']" @click="tabChange(item.value)">{{item.key}}</div>
        <el-input style="flex:1;" v-model="search" placeholder="搜索"    suffix-icon="el-icon-search" >
        </el-input>
    </div>
    <div v-if="list.length" class="content-list" id="content-list">
      <div class="list-item" v-for="(item,index) in list" :key="index">
        <div class="item-header">
          <span class="title">{{item.type}}</span>
          <span v-if="item.status === '待录入'" class="status status1">待录入</span>
          <span v-if="item.status === '待评估'" class="status status2">待评估</span>
          <span v-if="item.status === '已评估'" class="status status3">已评估</span>
        </div>
        <div class="item-content">
          <div class="item">
            <span class="name">评估人:</span>
            <span class="value">{{item.guestName}}</span>
          </div>
          <div class="item">
            <span class="name">发起人:</span>
            <span class="value">{{item.InitiateName}}</span>
          </div>
          <div class="item">
            <span class="name">发起时间:</span>
            <span class="value">{{ item.answerDate.split(' ')[0] }}</span>

          </div>
          <div class="btn">
            <span v-if="item.status === '已评估'" class="look" @click="loockReport(item.id)">查看报告</span>
            <template v-else>
              <span class="look" @click="goAs(item)">去评估</span>
              <span class="delete" @click="deleteAs(item.id)">删除</span>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="empty">
      暂无数据
    </div>

    <el-pagination
      class="pagination"
      background
      :current-page="currentPage"
      :page-size="pagesize"
      :pager-count="5"
      layout=" prev, pager, next"
      :total="paginationLength"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
export default {
 data(){
  return {
    activeIndex:0,
    tabList:[{
      key:'全部',
      value:0,
    },
    {
      key:'已评估',
      value:2,
    },
    {
      key:'未评估',
      value:1,
    }
    ],
    search:"",
    avaList:[],
    pagesize: 12,
    currentPage: 1,
  }
 },
  computed: {
    //列表数据
    list() {
        let listData = this.avaList
        if (this.search) {
            listData = this.avaList.filter(val => val.guestName.includes(this.search) || val.type.includes(this.search) || val.InitiateName.includes(this.search))
        }
        return listData.slice((this.currentPage - 1) * this.pagesize, (this.currentPage - 1) * this.pagesize + this.pagesize)
    },
    //总条数
    paginationLength() {
        if (this.search) {
            return this.avaList.filter(val => val.guestName.includes(this.search) || val.type.includes(this.search) || val.InitiateName.includes(this.search)).length
        } else {
            return this.avaList.length
        }

    },

},
 created(){
  this.getEvaList()
 },
 methods:{


  // tab切换
  tabChange(index){
    this.activeIndex = index
    this.currentPage = 1
    this.getEvaList()
  },

  //获取评估列表
  getEvaList() {
    this.$axios.post(`/Evaluate/EvaList?status=${this.activeIndex}`).then((res) => {
        const data =res.data
        this.avaList = data.obj
        this.$nextTick(() => {
          if(this.list.length)  document.getElementById('content-list').scrollTop = 0

        })
    })
  },

  //删除评估报告
  deleteAs(val) {
      this.$confirm('此操作将永久删除该报告, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          customClass:"as-body",
          type: 'warning'
      }).then(() => {
          this.$axios.post(`/Evaluate/DeleteEva/${val}`).then((res) => {
            this.getEvaList()
            this.$message.success({
              message:'删除成功',
              offset: 100
            });
          })
      }).catch(() => {
          return false
      });

  },

  // 去评估
  goAs(val){
    const {mbrCardNo,status,id,type,evaTypeid} =val
    this.$router.push({path:'/assessment/topic',query:{mbrCardNo,status,id,type,evaTypeid}})
  },

  // 查看报告
  loockReport(val){
    this.$router.push({path:'/assessment/report',query:{id:val}})
  },

  //下一页
  handleCurrentChange(val) {
      this.currentPage = val
      this.$nextTick(() => {
          if(this.list.length)  document.getElementById('content-list').scrollTop = 0
      })
  },
 }
}
</script>

<style scoped>

.empty {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
.pagination {
  width:100%;
  margin:0 auto;
  text-align: center;
  margin-top: 4px;
}
.as-list {
  height: 100%;
  display: flex;
  flex-direction: column;

}

.tab {
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 28px;
  line-height: 28px;
  text-align: center;
  border-radius: 16px;
  padding-right: 4px;
  background: #fff;
  font-size: 14px;
}

.tab-item {
  width: 21%;
  height: 100%;
  margin-right: 5px;
}

.as-list >>> .el-input__inner {
  height: 24px;
  border-radius:16px;
  background-color:#F6F6F6;
  border: 0;
}
.as-list >>> .el-input__icon {
 line-height: 1;
}

.tab-active {
  background: #029FD1;
  border-radius: 16px;
  color: #fff;
}

.content-list {
  flex: 1;
  line-height: 1;
  border-radius: 8px;
  overflow-y: auto;

}

.list-item {
  margin-top: 12px;
  background: #FFFFFF;
}

.item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding:12px 16px 9px 12px;
  border-bottom: 1px solid #E5E5E5;
}
.item-header .title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
}
.item-header .status {
  width: 38px;
  height: 16px;
  line-height: 16px;
  text-align: center;
  border-radius: 3px;
  font-size: 10px;
}

.status1 {
  background: #E8FEE1;
  color: #4CD964;
}
.status2 {
  background: #DFF4FF;
  color: #4CA6D9;
}
.status3 {
  background: #FFF9E5;
  color: #F4B856;
}

.item-content {
  position: relative;
  padding: 10px 16px;
}
.item-content .item {
  margin-bottom: 8px;
}
.item-content .item .name {
  font-size: 14px;
  color: #666666;
}
.item-content .item .value {
    font-size: 14px;
}

.btn {
  position: absolute;
  bottom: 12px;
  right: 12px;
}

.look {
  float: right;
  width: 76px;
  height: 28px;
  text-align: center;
  line-height: 28px;
  border-radius: 16px;
  margin-left: 8px;
  background: #029FD1;
  color: #fff;
  font-size: 14px;

}

.delete {
  float: right;
  width: 76px;
  height: 28px;
  text-align: center;
  line-height: 28px;
  border-radius: 16px;
  background: #FFC8C8;
  color: #FF4646;
  font-size: 14px;
}




</style>




// WEBPACK FOOTER //
// src/components/assessment/list.vue